import React, { useEffect, useState } from "react";
import { CartProvider } from "./context/CartContext";
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import ItemListContainer from "./Components/ItemListContainer/ItemListContainer";
import ItemDetailContainer from "./Components/ItemDetailContainer/ItemDetailContainer";
import Cart from "./Components/Cart/Cart";
import Checkout from "./Components/Checkout/Checkout";
import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import HeroSlider from "./Components/HeroSlider/HeroSlider";
import HeroInfo from "./Components/HeroInfo/HeroInfo";
import { db, auth } from "./db/firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminPanel from "./Components/AdminPanel/AdminPanel";
import WhatsappButton from "./Components/WhatsappButton/WhatsappButton";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDoc = await getDoc(doc(db, "usuarios", currentUser.uid));
        if (userDoc.exists()) {
          setUser({ uid: currentUser.uid, ...userDoc.data() });
        } else {
          setUser({
            uid: currentUser.uid,
            email: currentUser.email,
            rol: "cliente",
          });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading)
    return <div className="text-center mt-20 text-3xl">Cargando...</div>;

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  return (
    <BrowserRouter>
      <CartProvider>
        <div className="flex flex-col min-h-screen">
          <NavBar user={user} onLogout={handleLogout} />

          {/* 👇 Acá está el cambio importante */}
          <main className="flex-grow px-2 sm:px-4 md:px-8">
            {user && user.rol === "jefe" ? (
              <AdminPanel user={user} onLogout={handleLogout} />
            ) : (
              <>
                <Routes>
                  <Route path="/" element={<><HeroSlider /><HeroInfo /></>} />
                  <Route path="/category/:categoryId" element={<ItemListContainer />} />
                  <Route path="/category/:categoryId/:subcategoryId" element={<ItemListContainer />} />
                  <Route path="/item/:itemId" element={<ItemDetailContainer />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                </Routes>
                <WhatsappButton />
              </>
            )}

            {/* Modal de Login / Register */}
            {!user && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">
                  {showRegister ? (
                    <>
                      <Register
                        onRegister={(userData) => {
                          setUser(userData);
                          setShowRegister(false);
                        }}
                      />
                      <p className="text-center mt-4">
                        ¿Ya tienes cuenta?{" "}
                        <button
                          onClick={() => setShowRegister(false)}
                          className="text-blue-500 underline"
                        >
                          Inicia sesión
                        </button>
                      </p>
                    </>
                  ) : (
                    <>
                      <Login
                        onLogin={(userData) => {
                          setUser(userData);
                        }}
                      />
                      <p className="text-center mt-4">
                        ¿No tienes cuenta?{" "}
                        <button
                          onClick={() => setShowRegister(true)}
                          className="text-blue-500 underline"
                        >
                          Regístrate
                        </button>
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}
          </main>
          {/* 👆 Termina el main */}

          <Footer />
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
